import { clamp } from "@videojs/utils/number";
import { formatTime } from "@videojs/utils/time";
//#region src/core/ui/seek-indicator/status.ts
function isSeekIndicatorAction(action) {
	return action === "seekStep" || action === "seekToPercent";
}
function formatCurrentTime(snapshot) {
	return formatTime(snapshot.currentTime ?? 0, snapshot.duration);
}
function getSeekIndicatorDisplayValue(state) {
	return state.value ?? state.currentTime;
}
function getSeekToPercent(event) {
	if (event.value !== void 0) return clamp(event.value, 0, 100);
	if (!event.key || event.key < "0" || event.key > "9") return null;
	return Number(event.key) * 10;
}
function getSeekDirection(event, snapshot) {
	if (event.action === "seekStep" && event.value !== void 0) {
		if (event.value > 0) return "forward";
		if (event.value < 0) return "backward";
	}
	if (event.action === "seekToPercent") {
		const percent = getSeekToPercent(event);
		if (percent === null || snapshot.duration === void 0 || snapshot.duration <= 0) return null;
		const targetTime = percent / 100 * snapshot.duration;
		const currentTime = snapshot.currentTime ?? 0;
		if (targetTime > currentTime) return "forward";
		if (targetTime < currentTime) return "backward";
	}
	return null;
}
//#endregion
export { formatCurrentTime, getSeekDirection, getSeekIndicatorDisplayValue, getSeekToPercent, isSeekIndicatorAction };

//# sourceMappingURL=status.js.map